<template>
  <div class="main">
    <div class="title-bar">
      <div class="row">
        <div class="col-12 col-md-6 mb-3 mb-md-0 text-center text-md-left">
          <h1>Learning Path Enrollment</h1>
        </div>
        <div class="col-12 col-md-6 mb-4 mb-md-0 text-center text-md-right">
          <a
            v-if="$root.user.can_enroll"
            class="btn btn-primary"
            href="#"
            @click.prevent="addMyselfToQueue()"
            >Register Myself</a
          >
        </div>
      </div>
    </div>
    <div class="content p-4">
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" />
      </transition>
      <div class="row">
        <div class="col-12 col-xl-8 mb-5 mb-xl-0">
          <UserSearchForm
            enrollable-type="Learning Path"
            :enrollable-id="learningPath.id"
            :brands="learningPathBrands"
            :coworkers="coworkers"
            @add-to-queue="addToQueue"
          />
          <hr />
          <FormWrapper
            :action="formAction"
            method="POST"
            @submit="formSubmitted"
          >
            <h3 class="mb-4">Pending Enrollments</h3>
            <UserSearchQueue
              enrollable-type="Learning Path"
              :enrollable-id="learningPath.id"
              :queue="pending"
              @remove-from-queue="removeFromQueue"
            />
            <div class="mt-4 text-center text-xl-left">
              <button
                type="submit"
                class="btn btn-success mb-3 w-50 mb-sm-0 mr-sm-1 w-sm-auto"
                :class="{
                  disabled: pending.length === 0 || submitted === true,
                }"
              >
                Add to Queue
              </button>
              <a :href="cancelUrl" class="btn btn-danger w-50 ml-sm-1 w-sm-auto"
                >Cancel & Exit</a
              >
            </div>
          </FormWrapper>
        </div>
        <div class="col-12 col-xl-4">
          <div class="learning-path-details">
            <div class="learning-path-banner" :style="bannerStyle">
              <div class="overlay"></div>
              <div class="content py-3 text-center text-md-left p-md-4 p-xl-5">
                <h2 class="font-weight-bold px-2 p-md-0">
                  {{ learningPath.name }}
                </h2>
                <h4 class="px-2 p-md-0">{{ learningPath["length"] }}</h4>
              </div>
            </div>
            <div class="bg-white p-3 py-md-4 px-md-5">
              <LearningPathOverview
                :learningPath="learningPath"
                class="details-pane-table mb-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserSearchForm from "../partials/UserSearchForm";
import UserSearchQueue from "../partials/UserSearchQueue";
import DetailsPane from "components/listings/DetailsPane";
import LearningPathOverview from "components/partials/LearningPaths/LearningPathOverview";
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
  mixins: [DisplaysAlerts],

  components: {
    UserSearchForm,
    UserSearchQueue,
    DetailsPane,
    LearningPathOverview,
  },

  props: {
    learningPath: { type: Object, required: true },
    coworkers: { type: Array, default: () => [] },
    queue: { type: Object, required: true },
    referer: { type: String, default: null },
  },

  data() {
    return {
      pending: [],
      submitted: false,
    };
  },

  computed: {
    learningPathBrands() {
      return this.learningPath.brands.map((brand) => {
        return { label: brand.name, value: brand.id };
      });
    },
    formAction() {
      return this.route("enroll.online.learning-path.queue.save", {
        learning_path: this.learningPath.id,
      });
    },
    cancelUrl() {
      return this.referer || this.route("learning-paths.index");
    },
    bannerStyle() {
      var style = "";
      if (!!this.learningPath.image_url) {
        style = `background-image: url('${this.learningPath.image_url}');`;
      }
      return style;
    },
  },

  methods: {
    addMyselfToQueue() {
      var user = _.cloneDeep(this.$root.user);
      user.selectedBrand = _.cloneDeep(user.defaultBrand);
      this.addToQueue(user);
    },
    addToQueue(user) {
      if (this.isInQueue(user)) {
        alert(`You have already added ${user.name} to the pending queue.`);
        return;
      }
      this.pending.push(user);
    },
    removeFromQueue(user) {
      var queue = this.pending;
      this.pending = [];
      this.pending = queue.filter((item) => item.id !== user.id);
    },
    isInQueue(user) {
      return !!this.pending.find((item) => item.id === user.id);
    },
    formSubmitted() {
      this.submitted = true;
      this.$root.showLoading("Adding users to queue. Please wait...");
    },
  },
};
</script>